import { useUiStore } from '~/store/ui';

export default class MediaQuery {
  store = useUiStore();
  boundaries = {};
  mediaQueries = [];
  orientations = [];

  constructor() {
    this.init();
  }

  init() {
    this.watchMediaquery();
    this.watchOrientation();
  }

  watchMediaquery() {
    // get breakpoint boundaries from css vars
    const documentEl = window.getComputedStyle(document.documentElement);
    this.boundaries = {
      phoneUpper: documentEl.getPropertyValue('--bp-phone-upper'),
      tabletLower: documentEl.getPropertyValue('--bp-tablet-lower'),
      tabletUpper: documentEl.getPropertyValue('--bp-tablet-upper'),
      laptopLower: documentEl.getPropertyValue('--bp-laptop-lower'),
      laptopUpper: documentEl.getPropertyValue('--bp-laptop-upper'),
      desktopLower: documentEl.getPropertyValue('--bp-desktop-lower'),
    };

    // build media queries
    this.mediaQueries = [
      {
        name: 'phone',
        media: window.matchMedia(`screen and ( max-width: ${this.boundaries.phoneUpper} )`),
      },
      {
        name: 'tablet',
        media: window.matchMedia(`screen and ( min-width: ${this.boundaries.tabletLower} ) and (max-width: ${this.boundaries.tabletUpper})`),
      },
      {
        name: 'laptop',
        media: window.matchMedia(`screen and ( min-width: ${this.boundaries.laptopLower} ) and (max-width: ${this.boundaries.laptopUpper})`),
      },
      {
        name: 'desktop',
        media: window.matchMedia(`screen and ( min-width: ${this.boundaries.desktopLower} )`),
      },
    ];

    // add eventlistener for changes
    this.mediaQueries.forEach(query => query.media.addEventListener('change', this.getBreakpoint.bind(this)));

    // get initial breakpoint
    this.mediaQueries.forEach(query => this.getBreakpoint(query.media));
  }

  watchOrientation() {
    this.orientations = [
      {
        name: 'landscape',
        media: window.matchMedia(`screen and (orientation: landscape)`),
      },
      {
        name: 'portrait',
        media: window.matchMedia(`screen and (orientation: portrait)`),
      },
    ]

    // add eventlistener for changes
    this.orientations.forEach(query => query.media.addEventListener('change', this.getOrientation.bind(this)));

    // get initial orientation
    this.orientations.forEach(query => this.getOrientation(query.media));
  }

  getBreakpoint(event) {
    if (!event.matches) return;
    const query = this.mediaQueries.find(query => query.media.media === event.media);
    this.store.setBreakpoint(query.name);
  }

  getOrientation(event) {
    if (!event.matches) return;
    const query = this.orientations.find(query => query.media.media === event.media);
    this.store.setOrientation(query.name);
  }

}
